<template>
    <div class="home-main">
        <advertising-figure>
            <!--20220704zwj 文字描述由文字改成图片-->
            <!--<div class="ban-content">
                 <p class="text">中国土木工程学会2022年学术年会</p>
                <p class="text">第十九届中国土木工程詹天佑奖颁奖大会</p>
                <p class="text">中国土木工程学会成立110周年纪念大会</p>
                <button class="btn btn-default" @click="handleClickMore">
                    <span>查看详情</span>
                </button> 
            </div>-->
        </advertising-figure>

        <div class="about-meeting">
            <div class="meeting-wrap">
                <div class="meet-content">
                    <h2 class="tit">关于年会</h2>
                    <span class="sub">ABOUT THE ANNUAL MEETING</span>
                    <div class="meet-info">
                        <p class="text">
                            中国土木工程学会学术年会是紧密围绕国家发展战略，聚焦我国土木工程行业发展热点的前瞻性、基础性、应用性的高端学术交流活动，具有很强的科技引领与示范作用。学术年会每年召开一次，旨在团结带领广大土木工程专家和科技工作者，聚焦我国土木工程行业发展热点、难点及关键技术展开学术交流。
                        </p>
                        <p class="text">
                            近年来，中国土木工程学会召开了以“全面提升城市功能”、“智能土木”、“智慧城市与土木工程”、“中国土木工程与可持续发展”、“新基建与土木工程科学发展”等为主题的学术年会，是我国土木工程行业具有较大影响力的品牌学术活动。
                        </p>
                    </div>
                </div>
                <div class="meet-slider">
                    <el-carousel :height="bannerHeight + 'px'" :interval="4000">
                        <el-carousel-item v-for="item in sliderList" :key="item.id">
                            <img class="slider" ref="slider" :src="item.url" alt="" @load="imgLoad" />
                        </el-carousel-item>
                    </el-carousel>
                </div>
            </div>
        </div>

        <div class="tool-nav">
            <tool-nav :elGutter="40" :elSpan="8" />
        </div>

        <div class="over-years">
            <div class="meeting-style">
                <div class="title-wrap">
                    <h2 class="tit">历年年会风采</h2>
                    <!-- <p class="sub">是起点 不是终点,是起点 不是终点</p>
                    <el-button class="more" size="small" @click="jumToDetail">查看详情</el-button> -->
                </div>
                <div class="meeting-card">
                    <div class="year-slider">
                        <div class="wrapper" ref="ul" :style="{
                                transform: `translateX(${currentOffset}px)`,
                            }">
                            <div class="year-item" v-for="(item, idx) in yearsList" :key="idx">
                                <img :src="item.url" alt="" />
                            </div>
                        </div>
                    </div>
                    <div class="slide-btn-group">
                        <span @click="moveCarousel('left')" :disabled="atHeadOfList"><i class="el-icon-back"
                                :class="{ cur: atHeadOfList == true }"></i></span>
                        <span class="tps">精彩瞬间</span>
                        <span @click="moveCarousel('right')" :disabled="atEndOfList"><i class="el-icon-right"
                                :class="{ cur: atEndOfList == true }"></i></span>
                    </div>
                </div>
            </div>
            <div class="meeting-theme">
                <div class="theme-img" :style="{ opacity: opacity }">
                    <img :src="currentThemeImg" alt="" />
                </div>
                <div class="theme-title">
                    <!-- <h2 class="tit">历年年会主题名称</h2> -->
                    <h2 class="tit">中国土木工程学会{{currentyear}}年学术年会</h2>
                    <div class="theme-btn">
                        <!-- <span
                            :class="{ cur: isActive == idx }"
                            v-for="(item, idx) in partYear"
                            :key="idx"
                            @click="handlePartYear(idx)"
                            >{{ item.text }}</span
                        > -->
                        <span :class="{ cur: isActive == idx }" v-for="(item, idx) in dateandurl" :key="idx"
                            @click="handlePartYear(item,idx)">{{ item.cdate }}</span>
                        <!-- <a
                        :class="{ cur: isActive == idx }"
                            v-for="(item, idx) in dateandurl"
                            :key="idx"
                            @click="handlePartYear(item,idx)"
                        >{{ item.cdate }}</a> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import AdvertisingFigure from "@components/advertising";
    import ToolNav from "@components/tool-nav";
    // import CurrentConferMixin from "@/mixin/CurrentConference"
    import { Conference } from "@/store/entity/conference";
    import store from "@/store"

    export default {
        name: "HomePage",
        components: {
            AdvertisingFigure,
            ToolNav
        },
        // mixins: [CurrentConferMixin],
        data() {
            return {
                bannerHeight: "",
                sliderList: [
                    { id: 1, url: require("@assets/img/home-about.png") },
                    { id: 2, url: require("@assets/img/home-about.png") },
                    { id: 3, url: require("@assets/img/home-about.png") },
                    { id: 4, url: require("@assets/img/home-about.png") },
                ],

                /* 年会风采 */
                currentOffset: 0,
                windowSize: 1,
                paginationFactor: 695,
                // yearsList: [
                //     { id: 1, url: require("@assets/img/year-slide1.jpg") },
                //     { id: 2, url: require("@assets/img/year-slide2.jpg") },
                //     { id: 3, url: require("@assets/img/year-slide1.jpg") },
                // ],
                yearsList: [],
                /* 年会主题 */
                theme: [
                    { imgUrl: require("@assets/img/theme-img1.jpg") },
                    { imgUrl: require("@assets/img/theme-img2.jpg") },
                    { imgUrl: require("@assets/img/theme-img1.jpg") },
                ],
                opacity: 1,
                isActive: 0,
                currentThemeImg: "",
                partYear: [{ text: "2019" }, { text: "2020" }, { text: "2021" }],
                dateandurl: [],
                allyearsList: [],
                currentid: 0,
                currentyear: ""
            };
        },

        computed: {
            toolsList() {
                return [
                    {
                        id: 1,
                        name: "registration",
                        icon: require("@assets/img/tool-nav1.png"),
                        hoverIcon: "",
                        title: "我的报名",
                        subTitle: "My registration ",
                    },
                    {
                        id: 2,
                        name: "meeting",
                        icon: require("@assets/img/tool-nav2.png"),
                        hoverIcon: "",
                        title: "会议信息",
                        subTitle: "Meeting information ",
                    },
                    {
                        id: 3,
                        name: "live",
                        icon: require("@assets/img/tool-nav3.png"),
                        hoverIcon: "",
                        title: "会议直播",
                        subTitle: "Live streaming of the conference ",
                    },
                    {
                        id: 4,
                        name: "papers",
                        icon: require("@assets/img/tool-nav4.png"),
                        hoverIcon: "",
                        title: "论文投稿",
                        subTitle: "Submission of papers",
                    },
                    {
                        id: 5,
                        name: "projectVisit",
                        icon: require("@assets/img/tool-nav5.png"),
                        hoverIcon: "",
                        title: "项目参观",
                        subTitle: "Project visit",
                    },
                    {
                        id: 6,
                        name: "questions",
                        icon: require("@assets/img/tool-nav6.png"),
                        hoverIcon: "",
                        title: "调查问卷",
                        subTitle: "Questionnaire",
                    },
                ];
            },

            atEndOfList() {
                return (
                    this.currentOffset <=
                    this.paginationFactor *
                    -1 *
                    (this.yearsList.length - this.windowSize)
                );
            },
            atHeadOfList() {
                return this.currentOffset === 0;
            },
            // token: {
            //     get: function (){
            //         console.log("0")
            //         console.log(store.getters["auth/token"])
            //         return store.getters["auth/token"] || null
            //     },
            //     set (v){
            //         console.log(v)
            // if(v){
            //     console.log("2")
            //     this.getConferences();
            // }    
            //     }

            // }
            token() {
                return store.getters["auth/token"] || null
            }
        },

        mounted() {
            this.imgLoad();
            this.getConferences();
            this.resetConferences();
        },
        watch: {
            token: {
                handler(val) {
                    if (val.access_token) {
                        this.getConferences();
                    }
                },
                deep: true,
            },
        },
        methods: {
            handleClickMore() {
                let token = store.getters["auth/token"] || null
                let authorized = token && token.checkValid()
                if (authorized) {
                    this.$store.dispatch("conference/resetFetchConferenceInfo").then(() => {
                        this.$router.push({ name: "MeetingPage" })
                    })
                } else {
                    this.$message('请先登录');
                }
            },
            imgLoad() {
                this.$nextTick(() => {
                    this.bannerHeight = this.$refs.slider[0].height;
                });
            },

            moveCarousel(direction) {
                if (direction === "right" && !this.atEndOfList) {
                    this.currentOffset -= this.paginationFactor;
                } else if (direction === "left" && !this.atHeadOfList) {
                    this.currentOffset += this.paginationFactor;
                }
            },

            handlePartYear(item, idx) {
                this.isActive = idx;
                this.opacity = 0.1;
                setTimeout(() => {
                    this.opacity = 1;
                    this.currentThemeImg = item.url;
                }, 200);
                this.currentid = item.id
                this.currentyear = item.cdate
                console.log(this.allyearsList.find((x) => x.id == item.id))
                if (this.allyearsList.find((x) => x.id == item.id)) {
                    this.currentOffset = 0
                    this.yearsList = (this.allyearsList.find((x) => x.id == item.id)).list
                } else {
                    this.yearsList = []
                }
            },
            jumToDetail() {
                let token = store.getters["auth/token"] || null
                let authorized = token && token.checkValid()
                if (authorized) {
                    this.$store.dispatch("conference/changeConferenceInfo", { id: this.currentid }).then(() => {
                        this.$router.push({ name: "MeetingPage" })
                    })
                } else {
                    this.$message('请先登录');
                }
            },
            // handlePartYear(idx) {
            //     this.isActive = idx;
            //     this.opacity = 0.1;
            //     setTimeout(() => {
            //         this.opacity = 1;
            //         this.currentThemeImg = this.theme[idx].imgUrl;
            //     }, 200);

            // },
            getConferences() {
                let filters = {
                    showstatus: "是",
                    status: "过期"
                }
                Conference.getConferenceList(filters).then((res) => {

                    // this.dateandurl =  res.conference_list.map(function(value,index){
                    //         let newvalue = {}                   
                    //         // newvalue.cdate = this.$moment(value.conferencedate).format("YYYY") 
                    //         newvalue.cdate = value.conferencedate.slice(0,4)
                    //         newvalue.url = null
                    //         if(value.file_metadata){
                    //             newvalue.url = value.file_metadata[0].url
                    //         }
                    //         newvalue.id = value.id

                    //         this.yearsList.push.apply(this.yearsList, value.nicemoment)
                    //         return newvalue
                    //     })

                    // this.currentid = this.dateandurl[0].id
                    for (let i in res.conference_list) {
                        let newvalue = {}
                        newvalue.cdate = res.conference_list[i].conferencedate.slice(0, 4)
                        newvalue.url = null
                        if (res.conference_list[i].file_metadata) {
                            newvalue.url = res.conference_list[i].file_metadata[0].url
                        }
                        newvalue.id = res.conference_list[i].id
                        this.dateandurl.push(newvalue)
                        let allyearsObject = {}
                        if (res.conference_list[i].nicemoment) {
                            allyearsObject.id = res.conference_list[i].id
                            allyearsObject.list = res.conference_list[i].nicemoment
                            this.allyearsList.push(allyearsObject)
                        }
                    }
                    if (this.dateandurl.length > 0) {
                        this.currentid = this.dateandurl[0].id
                        this.currentyear = this.dateandurl[0].cdate
                        this.currentThemeImg = this.dateandurl[0].url
                        // let firstid = this.dateandurl[0].id
                        if (this.allyearsList.find((x) => x.id == this.dateandurl[0].id)) {
                            this.yearsList = (this.allyearsList.find((x) => x.id == this.dateandurl[0].id)).list
                        }
                    }

                })
            },
            resetConferences() {
                this.$store.dispatch("conference/resetFetchConferenceInfo")
            }

        },
    };
</script>

<style lang="scss" scoped>
    .home-main {
        width: 100%;
        min-width: 1200px;

        .ban-content {
            position: absolute;
            top: 35%;
            left: 0;
            right: 0;
            width: 1200px;
            padding: 0 15px;
            margin: 0 auto;
            z-index: 33;

            .text {
                font-size: 32px;
                color: #fff;
                margin-bottom: 10px;
                font-weight: bold;
            }

            .btn-default {
                font-size: 14px;
                border: none;
                padding: 10px 25px;
                color: $defaultColor;
                margin-top: 25px;
                background: rgba(255, 255, 255, 0.8);
            }
        }

        .about-meeting {
            width: 100%;
            padding: 60px 0;
            background: #eee;

            .meeting-wrap {
                display: flex;

                .meet-content {
                    flex: 40%;
                    padding: 0 15px;
                    margin-left: 360px;

                    .tit {
                        font-size: 24px;
                    }

                    .sub {
                        font-size: 12px;
                        color: #999;
                    }

                    .meet-info {
                        position: relative;
                        margin-top: 30px;
                        font-size: 14px;
                        padding: 0 15px;
                        line-height: 25px;

                        .text {
                            margin-bottom: 15px;
                        }

                        &:after {
                            content: "";
                            position: absolute;
                            top: 4px;
                            left: 0;
                            height: 0px;
                            width: 0px;
                            border-top: 8px solid transparent;
                            border-bottom: 8px solid transparent;
                            border-left: 8px solid #4e87e9;
                        }
                    }
                }

                .meet-slider {
                    flex: 60%;
                    padding: 0 15px;
                }
            }
        }

        .tool-nav {
            width: 100%;
            min-width: 1200px;
            max-width: 1200px;
            padding: 60px 15px;
            margin: 0 auto;

            .el-row {
                @include flex-start;
                flex-wrap: wrap;
                margin-top: -40px;
            }

            ::v-deep .el-col {
                margin-top: 40px;
            }

            ::v-deep .el-card {
                &:hover {
                    -webkit-transform: translateY(-3px);
                    -ms-transform: translateY(-3px);
                    transform: translateY(-3px);
                    box-shadow: 0 0 10px 2px rgba(254, 0, 0, 0.4);
                    background: $defaultColor;
                    border-color: $defaultColor;

                    .tit,
                    .sub {
                        color: #fff;
                    }
                }

                &.cur {
                    background: $defaultColor;
                }
            }
        }

        .over-years {
            @include flex-start;
            flex-wrap: wrap;
            padding: 60px 15px;
            margin-bottom: 60px;
            background: linear-gradient(to right,
                    $defaultColor 55%,
                    transparent 45%);

            .meeting-style {
                @include flex-start;
                width: 100%;
                overflow: hidden;
                color: #fff;

                .title-wrap {
                    flex: 0 0 25%;
                    margin-left: 360px;
                }

                .tit {
                    font-size: 42px;
                }

                .sub {
                    margin: 15px 0 30px;
                    font-size: 16px;
                }

                .more {
                    color: #fff;
                    padding: 10px 50px;
                    border-radius: 0;
                    font-size: 16px;
                    background: transparent;
                }

                .meeting-card {
                    position: relative;
                    margin-left: 60px;
                    height: 400px;
                }

                .year-slider {
                    width: 100%;
                    height: 100%;
                    overflow: hidden;

                    .wrapper {
                        height: 100%;
                        display: flex;
                        transition: transForm 0.3s ease-out;
                    }
                }

                .slide-btn-group {
                    position: absolute;
                    @include flex-around;
                    bottom: 15px;
                    left: -30px;
                    width: 140px;
                    height: 40px;
                    padding: 0 30px;
                    font-size: 14px;
                    box-sizing: content-box;
                    background: #fff;
                    z-index: 66;

                    .tps {
                        color: #003a8c;
                    }

                    i {
                        font-size: 16px;
                        color: #003a8c;
                        cursor: pointer;

                        &.cur {
                            color: #999;
                        }
                    }
                }

                .year-item {
                    width: 695px;
                    padding-right: 25px;

                    img {
                        display: block;
                        width: 100%;
                        height: 100%;
                    }
                }
            }

            .meeting-theme {
                @include flex-start;
                width: 1200px;
                margin: 0 auto;
                margin-top: 60px;

                .theme-img {
                    transition: opacity 0.3s linear;
                }

                .theme-title {
                    flex: 0 0 30%;
                    margin-left: 30px;

                    .tit {
                        font-size: 42px;
                        color: $defaultColor;
                    }

                    .theme-btn {
                        margin-top: 60px;

                        span {
                            font-size: 16px;
                            margin-right: 15px;
                            cursor: pointer;

                            &.cur {
                                color: $defaultColor;
                                font-size: 20px;
                            }
                        }

                    }
                }
            }
        }
    }
</style>